var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchicon = function SvgSearchicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#searchicon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#080A09",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m11.666 11.684 3 3m-1.333-7.333a6 6 0 1 0-12 0 6 6 0 0 0 12 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "searchicon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .018h16v16H0z"
  })))));
};
export default SvgSearchicon;